export const ELEMENT_CONSTANTS = {
  CONTAINER_ID: 'iframe-container',
  IFRAME_NAME: 'test-iframe',
  IFRAME_TITLE: 'Wix Chat',
  IFRAME_ID: 'test-iframe',
  IFRAME_CSS:
    'display:block;width:100%;height:100%;overflow:hidden;position:absolute;border-width:0',
};
